import type { Facet } from 'src/redux/productsQuery/types/Facet';

/** Matches query keys used in listings facet URLs (`f_…`). Used when replacing one facet’s params without rebuilding the full URL. */
export const facetKeyToListingsQueryParamName = (facetKey: string): string => {
  const shortenedKey = facetKey.replace(/^attributes\./, 'a.');
  return `f_${shortenedKey}`;
};

export const getListingsFacetsAsURLSearchParams = (facets: Facet[]): URLSearchParams => {
  const facetsWithActiveOptions = (facets || []).filter((facet) => {
    return facet.options.some((option) => option.active);
  });

  return facetsWithActiveOptions.reduce((urlParams, facet) => {
    facet.options.forEach((option) => {
      if (option.active) {
        const paramName = facetKeyToListingsQueryParamName(facet.key);
        urlParams.append(paramName, option.value);
      }
    });

    return urlParams;
  }, new URLSearchParams());
};
